import { type FC } from 'react';

import GridOnOutlined from '@mui/icons-material/GridOnOutlined';
import GroupWorkOutlined from '@mui/icons-material/GroupWorkOutlined';
import PeopleOutlined from '@mui/icons-material/PeopleOutlined';
import ReceiptLongOutlined from '@mui/icons-material/ReceiptLongOutlined';
import SchoolOutlined from '@mui/icons-material/SchoolOutlined';
import SettingsOutlined from '@mui/icons-material/SettingsOutlined';

import { SideNavButton } from '@/src/components/atoms/navButtons';

import { NavDivider } from './NavDivider';

export const AdminNavLinks: FC = () => (
  <>
    <SideNavButton icon={PeopleOutlined} page='manage-users'>
      People
    </SideNavButton>
    <SideNavButton icon={GroupWorkOutlined} page='learner-cohorts'>
      Cohorts
    </SideNavButton>
    <SideNavButton icon={SchoolOutlined} page='programs'>
      Programs
    </SideNavButton>
    <SideNavButton icon={GridOnOutlined} page='rubrics'>
      Rubrics
    </SideNavButton>
    <SideNavButton
      activePages={[
        'raps',
        'rap-assigned-learners',
        'rap-competencies',
        'rap-plan',
        'rap-program',
        'rap-level',
        'rap',
      ]}
      icon={ReceiptLongOutlined}
      page='raps'
    >
      RAPs
    </SideNavButton>
    <NavDivider />
    <SideNavButton icon={SettingsOutlined} page='settings'>
      Settings
    </SideNavButton>
  </>
);
